<template>
	<div class="f-image" v-if="field">
		<div
		v-if="field.disabled && field.value">
			<img style="max-height: 450px;" :src="field.value" :alt="field.title">
		</div>
		<CroppableImage
		v-else-if="$store.getters['features/croppa'] && field.options && field.options.width && field.options.height"

		:id="(field.options.id ? field.options.id : 0)"
		:fieldname="(field.id ? field.id : 'image')"
		:type="(field.options.type ? field.options.type : 'assets')"
		:width="field.options.width"
		:height="field.options.height"></CroppableImage>
		<vue-dropzone
		v-else
		ref="dropzone"
		id="dropzone"
		vdropzone-success="uploadSuccess"
		:options="dropzoneOptions"></vue-dropzone>
	</div>
</template>


<script>
import vueDropzone from 'vue2-dropzone';
import help_general from '@/helpers/general';
import fieldvalidation from '@/helpers/fieldvalidation';

import CroppableImage from '@/components/CroppableImage';

export default {
	name: 'f-image',
	components: {
		vueDropzone,
		CroppableImage,
    },
	props: {
		field: {
			type: Object,
			default(){
				return {};
			}
		}
	},
	data() {
  		const channel = this.$store.getters.channel;
		return {
			fileEl: null,
			value: '',
			croppa: {},
			dropzoneOptions: {
				acceptedFiles: "image/*",
				paramName: '',
				maxFiles: 1,
				addRemoveLinks: true,
				url: channel.urls.assets.replace(':fieldname:', 'asset'),
				thumbnailWidth: 400,
				thumbnailHeight: 300,
				maxFilesize: 5 // 5 MB
	      	}
		};
	},
	created(){
		this.dropzoneOptions.paramName = this.field.name;
		if(this.field.action) this.dropzoneOptions.url = this.field.action;
	},
	mounted(){
		if(this.$refs.dropzone && this.field.value){
			this.value = this.field.value;
			const size = (this.field.size ? this.field.size : 0);

			var mockFile = { name: help_general.basename(this.field.value), size};
			this.$refs.dropzone.manuallyAddFile(mockFile, this.field.value);
		}
	},
	methods: {
		...fieldvalidation,
		uploadSuccess(file, response){
			console.log('uploadSuccess', file, response);
		}
	}
}
</script>

<style scoped>
	.vue-dropzone {
		padding: 0;
		background-color: rgba(228,230,235,0.2);
		border: 1px solid #D1D5DD;
	}
	.dz-preview {
		margin: 1em;
	}
	.vue-dropzone .dz-preview .dz-details {
		background-color: rgba(#000, 0.5);
	}

	.croppa-container canvas {
		display: block;
	}
</style>



// WEBPACK FOOTER //
// src/components/form/f-image.vue